import React, { Component } from "react";

import "./consulta-order-view.css";

import AppContext from "../../appContext";
import ServicesUtils from "../../shared/utils/ServicesUtils";
import { getConectaPedido } from "../../Functions/gestao-pedidos-laboratorios/get-conecta-pedido";
import { downloadPedidoJson } from "../utils/download-json";

import Moment from "moment";
import { Printer, Download } from "react-bootstrap-icons";
import ReactToPrint from "react-to-print";

class ConsultaOrderView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      order: null,
    };
    this.printRef = React.createRef();
    this.baixarJson = this.baixarJson.bind(this);
    ConsultaOrderView.contextType = AppContext;
  }

  componentDidMount() {
    this.fetchOrderData();
  }

  async fetchOrderData() {
    this.context.showLoading("");

    const { status, pedido } = await getConectaPedido({
      id: this.props.pedidoId,
      laboratorio: this.props.laboratorio,
    });

    if (status !== 200 || !pedido) {
      this.setState({ loading: false });
      this.context.hideLoading();
      return;
    }

    this.setState({ order: pedido, loading: false });
    this.context.hideLoading();
  }

  baixarJson() {
    if (this.state.order) {
      downloadPedidoJson(this.state.order, `pedido-${this.props.idPedidoOpticlick || this.props.pedidoId}.json`);
    }
  }

  val(value) {
    return value !== undefined && value !== null && value !== "" && value !== "null" && value !== "undefined" ? value : "-";
  }

  hasData(...values) {
    return values.some(value => value !== undefined && value !== null && value !== "" && value !== "null" && value !== "undefined");
  }

  renderSemDados() {
    return (
      <div className="cov-no-data">
        <span>Sem dados</span>
      </div>
    );
  }

  renderEye(label, olho, parametros) {
    if (!olho) {
      return (
        <div className="cov-eye">
          <div className="cov-eye-title">{label}</div>
          <div className="cov-eye-body cov-eye-no-data">
            <span>Sem dados</span>
          </div>
        </div>
      );
    }

    const produto = olho.produto || "";
    const esf = this.val(olho.grauEsferico);
    const cil = olho.grauCilindro === "0.00" ? "" : this.val(olho.grauCilindro);
    const eixo = this.val(olho.eixo);
    const adicao = this.val(olho.adicao);
    const dnp = this.val(olho.dnp);
    const alt = this.val(olho.altura);

    let pertoEsf = "-";
    if (olho.grauEsferico && olho.adicao) {
      const esfNum = parseFloat(String(olho.grauEsferico).replace(",", "."));
      const addNum = parseFloat(String(olho.adicao).replace(",", "."));
      if (!isNaN(esfNum) && !isNaN(addNum)) {
        pertoEsf = (esfNum + addNum).toFixed(2).replace(",", ".");
      }
    }

    const dnpPerto = this.val(parametros?.dnpPerto);
    const cro = this.val(parametros?.cro);
    const distVertice = this.val(parametros?.distanciaVertice);
    const bOpticlick = this.val(parametros?.base || olho.base);
    const ct = this.val(olho.ct);
    const et = this.val(olho.et);

    const prismaH = this.val(olho.valorPrismaHorizontal);
    const prismaHEixo = this.val(olho.eixoPrismaHorizontal);
    const prismaV = this.val(olho.valorPrismaVertical);
    const prismaVEixo = this.val(olho.eixoPrismaVertical);

    const hasPrisma = [olho.valorPrismaHorizontal, olho.eixoPrismaHorizontal, olho.valorPrismaVertical, olho.eixoPrismaVertical].some(
      v => v !== undefined && v !== null && v !== "" && v !== "0" && v !== 0
    );

    return (
      <div className="cov-eye">
        <div className="cov-eye-title">{label}</div>
        <div className="cov-eye-body">
          <div className="cov-eye-lente text-left">
            <strong>Lente: </strong>
            {produto || "-"}
          </div>

          <table className="cov-table">
            <thead>
              <tr>
                <th></th>
                <th>Esf.</th>
                <th>Cil.</th>
                <th>Eixo</th>
                <th>Adição</th>
                <th>DNP</th>
                <th>Alt.</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="cov-label-cell">
                  <span className="cov-badge">LONGE</span>
                </td>
                <td>{esf}</td>
                <td>{cil}</td>
                <td>{eixo}</td>
                <td>{adicao}</td>
                <td>{dnp}</td>
                <td>{alt}</td>
              </tr>
              <tr>
                <td className="cov-label-cell">
                  <span className="cov-badge">PERTO</span>
                </td>
                <td>{pertoEsf}</td>
                <td>{cil}</td>
                <td>{eixo}</td>
                <td colSpan="3"></td>
              </tr>
            </tbody>
          </table>

          <table className="cov-table">
            <thead>
              <tr>
                <th>DNP Perto</th>
                <th>CRO</th>
                <th>Dist. Vertice</th>
                <th>B. Opticlick</th>
                <th>CT</th>
                <th>ET</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{dnpPerto}</td>
                <td>{cro}</td>
                <td>{distVertice}</td>
                <td>{bOpticlick}</td>
                <td>{ct}</td>
                <td>{et}</td>
              </tr>
            </tbody>
          </table>

          {hasPrisma && (
            <table className="cov-table">
              <thead>
                <tr>
                  <th>Prisma H.</th>
                  <th>Base</th>
                  <th>Prisma V.</th>
                  <th>Base</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{prismaH}</td>
                  <td>{prismaHEixo}</td>
                  <td>{prismaV}</td>
                  <td>{prismaVEixo}</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }

  renderMedidasPersonalizadas(json) {
    const params = json?.parametros;
    const paciente = json?.paciente;
    if (!params) return null;

    const olho = params.olhoDireito || params.olhoEsquerdo;
    if (!olho && !paciente?.iniciaisPaciente && !params.olhoDominante) return null;

    const items = [
      { label: "Iniciais Cliente", value: paciente?.iniciaisPaciente },
      { label: "Conformador Cabeça Olhos", value: olho?.coeficienteHE },
      { label: "Distância Leitura", value: olho?.distanciaLeitura },
      { label: "Estabilidade", value: olho?.coeficienteST },
      { label: "CVP", value: olho?.cvp },
      { label: "Distância Progressão", value: olho?.distanciaProgressao },
      { label: "Ângulo Pantoscópico", value: olho?.anguloPantoscopico },
      { label: "Curvatura Armação", value: olho?.anguloCurvatura },
      { label: "Olho Dominante", value: params.olhoDominante },
    ];

    const allEmpty = !items.some(i => this.hasData(i.value));

    return (
      <div className="cov-section">
        <div className="cov-section-title">Medidas Personalizadas</div>
        <div className="cov-section-body">
          {allEmpty ? (
            this.renderSemDados()
          ) : (
            <table className="cov-armacao-table">
              <thead>
                <tr>
                  {items.map((item, idx) => (
                    <th key={idx}>{item.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {items.map((item, idx) => (
                    <td key={idx}>{this.val(item.value)}</td>
                  ))}
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }

  renderServicos(json) {
    const ar = ServicesUtils.getAntirreflexoPreferido(json?.servicos);
    const coloracao = json?.servicos?.find(s => s.tipo === "COLORACAO");
    const montagem = json?.servicos?.find(s => s.tipo === "MONTAGEM");
    const cor = json?.corColoracao?.descricao || "";
    const hasServicos = ar || coloracao || montagem || cor;

    return (
      <div className="cov-section">
        <div className="cov-section-title">Serviços</div>
        <div className="cov-section-body">
          {hasServicos ? (
            <div className="cov-servicos-row">
              {ar && (
                <span>
                  <strong>AR</strong> {ar.descricao}
                </span>
              )}
              {coloracao && (
                <span className="text-left">
                  <strong>COLORAÇÃO</strong> {coloracao.descricao || "-"}
                </span>
              )}
              {cor && (
                <span className="text-left">
                  <strong>COR</strong> {cor}
                </span>
              )}
              {montagem && (
                <span>
                  <strong>CORTE/MONTAGEM</strong> {montagem.descricao}
                </span>
              )}
            </div>
          ) : (
            this.renderSemDados()
          )}
        </div>
      </div>
    );
  }

  renderArmacao(json) {
    const arm = json?.armacao;
    if (!arm) return null;

    const cor = arm.descricaoCor || arm.cor?.descricao || (typeof arm.cor === "string" ? arm.cor : "");
    const formatoAro = arm.modelo || arm.modeloCodigoRef;
    const armacaoVazia = !this.hasData(arm.vertical, arm.horizontal, arm.diametroMaior, arm.ponte, arm.referencia, cor, arm.marca, formatoAro);

    return (
      <div className="cov-section">
        <div className="cov-section-title">Armação</div>
        <div className="cov-section-body">
          {armacaoVazia ? (
            this.renderSemDados()
          ) : (
            <table className="cov-armacao-table">
              <thead>
                <tr>
                  <th>Vertical</th>
                  <th>Horizontal</th>
                  <th>Diagonal Maior</th>
                  <th>Ponte</th>
                  <th>Referência</th>
                  <th>Cor</th>
                  <th>Marca</th>
                  <th>Formato do Aro</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{this.val(arm.vertical)}</td>
                  <td>{this.val(arm.horizontal)}</td>
                  <td>{this.val(arm.diametroMaior)}</td>
                  <td>{this.val(arm.ponte)}</td>
                  <td>{this.val(arm.referencia)}</td>
                  <td>{this.val(cor)}</td>
                  <td>{this.val(arm.marca)}</td>
                  <td>{this.val(formatoAro)}</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }

  renderPromocao(json) {
    const promo = json?.promocao;
    const custo = promo?.custo;
    const promocaoVazia = !this.hasData(promo?.voucher, promo?.campanha?.nome, promo?.campanha?.tipo, promo?.idPar);

    return (
      <div className="cov-section">
        <div className="cov-section-title">Promoção</div>
        <div className="cov-section-body">
          {promocaoVazia ? (
            this.renderSemDados()
          ) : (
            <table className="cov-armacao-table">
              <thead>
                <tr>
                  <th>Cupom</th>
                  <th>Nome Promoção</th>
                  <th>Tipo</th>
                  <th>Par</th>
                  <th>Desconto Percentual</th>
                  <th>Tipo de Desconto</th>
                  <th>Valor Adicional</th>
                  <th>Valor Fixo</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{this.val(promo?.voucher)}</td>
                  <td>{this.val(promo?.campanha?.nome)}</td>
                  <td>{this.val(promo?.campanha?.tipo)}</td>
                  <td>{this.val(promo?.idPar)}</td>
                  <td>{this.val(custo?.descontoPercentual)}</td>
                  <td>{this.val(custo?.tipoDesconto)}</td>
                  <td>{this.val(custo?.valorAdicional)}</td>
                  <td>{this.val(custo?.valorFixo)}</td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }

  renderObservacoes(json) {
    if (!json?.observacao) return null;

    return (
      <div className="cov-section">
        <div className="cov-section-title">Observações</div>
        <div className="cov-section-body">
          <p>{json.observacao}</p>
        </div>
      </div>
    );
  }

  renderOutrasInformacoes(json) {
    const items = [
      { label: "Empresa de Faturamento", value: json?.cliente?.empresaFaturamento },
      { label: "Nome do Cliente", value: json?.paciente?.nome },
      { label: "CPF do Cliente", value: json?.paciente?.cpf },
      { label: "Nome do Médico", value: json?.medico?.nome },
      { label: "CPF/CRM do Médico", value: json?.medico?.crm },
    ].filter(i => i.value !== undefined && i.value !== null && i.value !== "");

    if (items.length === 0) return null;

    return (
      <div className="cov-section">
        <div className="cov-section-title">Outras Informações</div>
        <div className="cov-section-body">
          <div className="cov-info-grid">
            {items.map((item, idx) => (
              <div className="cov-info-item" key={idx}>
                <span>{item.label}:</span>
                <span>{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return <div className="cov-loading">Carregando pedido...</div>;
    }

    if (!this.state.order) {
      return <div className="cov-loading">Não foi possível carregar o pedido.</div>;
    }

    const order = this.state.order;

    return (
      <div className="cov" ref={this.printRef}>
        <div className="cov-header">
          <div className="cov-header-logo">
            <img src="image/modulos/Conecta_Consulta.png" alt="Conecta Consulta" className="module_logo-img" />
          </div>
          <div className="cov-header-left text-left">
            <span>
              <strong>Pedido Essilor:</strong> {this.val(this.props.idPedidoOpticlick)}
            </span>
            <span>
              <strong>Pedido Ótica:</strong> {this.val(this.props.idPedidoOtica)}
            </span>
            <span>
              <strong>Data do Pedido:</strong> {this.props.dataCriacao ? Moment(this.props.dataCriacao).format("DD/MM/YYYY") : "-"}
            </span>
          </div>
          <div className="cov-header-right">
            <ReactToPrint
              trigger={() => (
                <button className="cov-action-link">
                  <Printer size={14} />
                  Imprimir Pedido
                </button>
              )}
              content={() => this.printRef.current}
              documentTitle={`Essilor Conecta - Pedido ${this.props.idPedidoOpticlick || this.props.pedidoId}`}
            />
            <button className="cov-action-link" onClick={this.baixarJson}>
              <Download size={14} />
              Baixar JSON
            </button>
          </div>
        </div>

        <div className="cov-eyes">
          {this.renderEye("Olho Direito", order.receita?.olhoDireito, order.parametros?.olhoDireito)}
          {this.renderEye("Olho Esquerdo", order.receita?.olhoEsquerdo, order.parametros?.olhoEsquerdo)}
        </div>

        {this.renderMedidasPersonalizadas(order)}
        {this.renderServicos(order)}
        {this.renderArmacao(order)}
        {this.renderPromocao(order)}
        {this.renderObservacoes(order)}
        {this.renderOutrasInformacoes(order)}
      </div>
    );
  }
}

export default ConsultaOrderView;
